import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { createFileRoute } from '@tanstack/react-router'
import { CheckCircle2 } from 'lucide-react'

export const Route = createFileRoute('/_dashboard/subscription/success')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex justify-center items-center p-4 min-h-[calc(100vh-4rem)]">
      <div className="w-full max-w-2xl">
        <div className="mb-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full">
              <CheckCircle2 className="w-8 h-8 text-primary" />
            </div>
          </div>
          <h1 className="mb-3 text-3xl font-bold text-gray-900 dark:text-gray-100">
            Thank You for Subscribing!
          </h1>
          <p className="text-base text-gray-600 dark:text-gray-400">
            Your subscription is now active
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="text-xl">You're all set</CardTitle>
            <CardDescription>
              You now have full access to all Rocket Rank features
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <div className="flex items-center justify-center w-5 h-5 rounded-full">
                    <span className="text-xs text-gray-600 dark:text-gray-400">
                      1
                    </span>
                  </div>
                </div>
                <div>
                  <p className="font-medium text-gray-900 dark:text-gray-100">
                    Generate high-quality content
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    Create SEO-optimized articles that rank on Google
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <div className="flex items-center justify-center w-5 h-5 rounded-full">
                    <span className="text-xs text-gray-600 dark:text-gray-400">
                      2
                    </span>
                  </div>
                </div>
                <div>
                  <p className="font-medium text-gray-900 dark:text-gray-100">
                    Schedule your content
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    Plan and automate your content calendar
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <div className="flex items-center justify-center w-5 h-5 rounded-full">
                    <span className="text-xs text-gray-600 dark:text-gray-400">
                      3
                    </span>
                  </div>
                </div>
                <div>
                  <p className="font-medium text-gray-900 dark:text-gray-100">
                    Track your performance
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    Monitor your rankings and optimize your strategy
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-4 border-t text-sm text-gray-600 dark:text-gray-400">
              <p>
                Need help getting started? Contact our support team at{' '}
                <a
                  href="mailto:support@userocketrank.com"
                  className="text-primary hover:underline"
                >
                  support@userocketrank.com
                </a>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
